export enum DefaultOriginIdEnum {
  DEFAULT = 'default',
  DEFAULT_SEARCH = 'natural' // Kroger
}

export enum PredictiveOriginIdEnum {
  EMPATHIZE_TRENDING = 'empathize_trending',
  TRENDING = 'trending', // Kroger
  HISTORY = 'history',
  HISTORICAL = 'historical' // Kroger
}

export enum RefinementOriginIdEnum {
  EMPATHIZE = 'empathize_term',
  AUTOCOMPLETE = 'autocomplete', // Kroger
  EMPATHIZE_CATEGORY = 'empathize_category',
  RELATED_TAG = 'related_tag',
  RELATED_TAGS = 'related tag', // Kroger
  RELATED = 'related', // Zara
  EMPATHIZE_NEXT_QUERIES = 'empathize_next_queries',
  NEXT_QUERY = 'next_query',
  WHATS_NEXT = 'whats next', // Kroger
  WHATS_NEXT_CAROUSEL = 'whats next carousel', // Kroger
  PARTIALS = 'partials', // Kroger
  SPELLCHECK = 'spellcheck'
}

export const OriginIdEnum = {
  ...DefaultOriginIdEnum,
  ...PredictiveOriginIdEnum,
  ...RefinementOriginIdEnum
};
export type OriginIdEnum = (
  DefaultOriginIdEnum
  | PredictiveOriginIdEnum
  | RefinementOriginIdEnum
  );
